export default __webpack_public_path__ + "static/media/Major Rune Stone of the Pit Fighter.8e2d861a.jpg";